const CHUNK_RELOAD_KEY = "fq_chunk_reload_attempted";
const GLOBAL_RECOVERY_KEY = "__FQ_CHUNK_LOAD_RECOVERY_INSTALLED__";

export const isChunkLoadError = (error) => {
  const name = String(error?.name || "");
  const message = String(error?.message || error || "");
  const stack = String(error?.stack || "");
  const combined = `${name}\n${message}\n${stack}`;
  return (
    /ChunkLoadError/i.test(combined) ||
    /Loading chunk\s+\S+\s+failed/i.test(combined) ||
    /static\/js\/.+\.chunk\.js/i.test(combined) ||
    /\.chunk\.js/i.test(combined)
  );
};

export const getChunkLoadDebugContext = () => {
  const scriptSources =
    typeof document !== "undefined"
      ? Array.from(document.scripts || [])
          .map((script) => script.src)
          .filter(Boolean)
          .slice(-8)
      : [];

  return {
    online:
      typeof navigator !== "undefined" && "onLine" in navigator
        ? navigator.onLine
        : null,
    currentUrl: typeof window !== "undefined" ? window.location.href : "",
    origin: typeof window !== "undefined" ? window.location.origin : "",
    baseUri: typeof document !== "undefined" ? document.baseURI || "" : "",
    publicUrl:
      typeof process !== "undefined" ? process.env.PUBLIC_URL || "" : "",
    serviceWorkerController:
      typeof navigator !== "undefined"
        ? navigator.serviceWorker?.controller?.scriptURL || ""
        : "",
    recentScripts: scriptSources,
    timestamp: new Date().toISOString(),
  };
};

export const resetChunkLoadReloadGuard = () => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch (error) {
    // Session storage can be unavailable in private or locked-down contexts.
  }
};

export const handleChunkLoadErrorRecovery = (
  error,
  { source = "unknown", autoReload = true } = {}
) => {
  if (!isChunkLoadError(error)) return false;

  const context = getChunkLoadDebugContext();
  console.error("FABRIQUOTE_CHUNK_LOAD_ERROR", {
    source,
    name: error?.name || "",
    message: error?.message || String(error || ""),
    stack: error?.stack || "",
    ...context,
  });

  if (!autoReload || typeof window === "undefined") {
    return true;
  }

  try {
    if (!window.sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      window.sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
      window.location.reload();
    }
  } catch (storageError) {
    window.location.reload();
  }

  return true;
};

export const installGlobalChunkLoadErrorRecovery = () => {
  if (typeof window === "undefined") return;
  if (window[GLOBAL_RECOVERY_KEY]) return;
  window[GLOBAL_RECOVERY_KEY] = true;

  window.addEventListener("error", (event) => {
    handleChunkLoadErrorRecovery(event?.error || event?.message, {
      source: "window.error",
      autoReload: true,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    handleChunkLoadErrorRecovery(event?.reason, {
      source: "window.unhandledrejection",
      autoReload: true,
    });
  });
};
